import { render } from "./PopoversPage.vue?vue&type=template&id=aede0ac4&ts=true"
import script from "./PopoversPage.vue?vue&type=script&lang=ts"
export * from "./PopoversPage.vue?vue&type=script&lang=ts"

import exportComponent from "../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__